export default __webpack_public_path__ + "static/media/mail.f0abd5a5.svg";